// extracted by mini-css-extract-plugin
module.exports = {"root":"VerifiedBlock_root__3VFrC"};